import React, { Children, ReactElement } from 'react';
import { Grid } from '../grid/Grid';
import { Cell } from '../grid/Cell';
import styles from './RadioGroup.module.scss';

export const RadioGroup = ({ children }: Props) => (
    <Grid gap='s' align='stretch' justify='start' direction='row' wrap>
        {Children.map(children, child => (
            <Cell key={child.props.value} className={styles.cell}>
                {child}
            </Cell>
        ))}
    </Grid>
);

type Props = { children: ReactElement[] };
